<style lang="scss" scoped>
.app-header {
  height: $header_height;
  width: 100%;
  border-bottom: 1px solid $border-color-base;
  position: absolute;
  left: 0;
  top: 0;

  .app-logo-container {
    width: $side_bar_width;
    height: $header_height;
    border-right: 1px solid $border-color-base;
    float: left;
    position: relative;
    box-sizing: border-box;

    div.logo {
      position: absolute;
      left: 0;
      top: 0;
      cursor: pointer;
      background: url(/static/img/logo-b.svg) no-repeat;
      border-bottom: 1px solid #000;
      background-color: $bg-color-dark;
      background-position: center center;
      background-size: 71% 71%;
      z-index: 1000;
      width: $side_bar_width;
      height: $header_height;
    }
  }

  .header_nav {
    height: $header_height;
    background-color: #fff;
    padding-left: $side_bar_width;
    box-sizing: border-box;
    border-bottom: 1px solid $border-color-base;

    .header_lft_pannel {
      height: $header_height;
      position: relative;
      font-size: 16px;
      padding-left: 30px;
      color: $text-regular;

      span.return_icon {
        display: inline-block;
        width: 28px;
        height: 28px;
        margin-top: 18px;
        cursor: pointer;
        transform: rotate(180deg);
        border: 1px solid $border-color-base;
        border-radius: 50%;
        text-align: center;
        line-height: 28px;

        &:hover {
          color: $color-primary;
        }

        &:active {
          opacity: 0.8;
          border-color: $color-primary;
        }
      }

      .go-back {
        float: left;
        font-size: 12px;
        line-height: 18px;
        margin-top: 25px;
        margin-right: 5px;

        span.split {
          color: #999;
        }
      }

      .page_title {
        font-size: 12px;
        line-height: 18px;
        display: inline-block;
        margin-top: 25px;
      }
    }

    .header_rt_pannel {
      position: relative;
      height: 100%;
      line-height: $header_height;

      .userlogo {
        text-align: center;
        color: #fff;
        margin-right: 8px;
        cursor: pointer;

        img {
          border-radius: 50%;
          width: 36px;
          height: 36px;
          vertical-align: middle;
          position: relative;
          top: -1px;
        }
      }

      .header_dropdown {
        padding-right: 10px;
        height: 100%;
        box-sizing: border-box;
        cursor: pointer;
      }

      .namespace {
        cursor: pointer;
        font-size: 12px;

        > div.name {
          line-height: $header_height;
          margin-right: 5px;
          cursor: pointer;
        }

        > div.down-list {
          display: none;
          position: absolute;
          right: 10px;
          top: 52px;
          padding-top: 10px;
          z-index: 6000;

          s.arrows-up {
            display: block;
            position: absolute;
            width: 8px;
            height: 8px;
            border: 1px solid $border-color-base;
            border-right: 0 none;
            border-bottom: 0 none;
            transform: rotate(45deg);
            top: 6px;
            right: 14px;
            border-radius: 1px;
            background-color: #fff;
          }

          ul {
            border: 1px solid $border-color-base;
            box-shadow: 0 6px 7px 0 rgba(225, 227, 230, 0.58);
            background-color: #fff;
            border-radius: 2px;
            line-height: 16px;
            padding: 18px;
            width: 68px;

            > li > span.logout-link {
              user-select: none;

              i {
                font-size: 14px;
              }
            }

            > li > span.logout-link:hover {
              color: $color-danger;
            }

            > li > span.logout-link:active {
              opacity: 0.5;
            }
          }
        }

        > div.logout_btn {
          line-height: $header_height;
          position: relative;
          margin-right: 20px;

          > i {
            display: inline-block;
            font-size: 10px;
            color: $text-primary;
            font-weight: 700;
            transform: rotate(90deg) scale(0.7);
            transition: all 0.3s;
            height: 14px;
            line-height: 14px;
            position: relative;
          }
        }

        &:hover {
          > div.logout_btn > i {
            transform-origin: 50% 50%;
            transform: rotate(540deg) scale(0.7);
          }

          > div.down-list {
            display: block;
          }
        }
      }
    }
  }
}
</style>
<template>
  <div class="app-header clearfix">
    <div class="app-logo-container">
      <div class="logo" @click="toWWWAgotoZ"></div>
    </div>
    <div class="header_nav">
      <div class="header_lft_pannel az-lft">
        <div class="go-back" v-if="isBack">
          <el-link type="primary" @click="goBackHandler">返回</el-link><span
            class="split">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </div>
        <div class="page_title az-lft">
          <span v-for="(crumb, index) in crumbs" :key="crumb.name">
            <template v-if="index !=0">&nbsp;>&nbsp;</template>
            <template v-if="index < crumbs.length - 1">
              <el-link type="primary" @click="$router.push(crumb.path)">{{crumb.title}}
                <span v-if="title_label && index == crumbs.length -1 &&
                  label_remark_index === 'next-last'">
                  （{{label_remark}}）
                </span>
                <span v-else-if="!title_label && index == crumbs.length -2 &&
                  label_remark_index === 'next-last'">
                  （{{label_remark}}）
                </span>
              </el-link>
            </template>
            <template v-else>{{crumb.title}}</template>

          </span>
          <span v-if="title_label">&nbsp;>&nbsp;{{title_label}}</span>
          <span
            v-if="label_remark && label_remark_index === 'last'">({{label_remark}})</span>
        </div>
      </div>
      <div class="header_rt_pannel az-rt clearfix">
        <div class="userlogo az-lft">
          <img src="/static/img/avatar.svg">
        </div>
        <div class="az-lft namespace clearfix">
          <div class="name az-lft">
            {{username}}
          </div>
          <div class="logout_btn az-lft">
            <i class="iconfont oaicon-triangle-arrows"></i>
          </div>
          <div class="down-list">
            <s class="arrows-up"></s>
            <ul>
              <li class="logout">
                <span @click="confirmLogoutHandler" class="logout-link">
                  <i class="azappfont az-app-logout"></i>&nbsp;退出登录
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
/* @flow */
export default {
  name: 'app-header',
  data() {
    return {
      title: this.$route.meta.title,
      dynamicTitle: this.$route.meta.dynamicTitle,
      isBack: this.$route.meta.isBack,
      logoutIsOpen: false,
      logoutBtnIsLoading: false,
      title_label: this.$route.query.title_label,
      label_remark: this.$route.query.label_remark,
      label_remark_index: this.$route.query.label_remark_index || 'last', // last // next-last
      crumbs: []
    };
  },
  watch: {
    '$route': 'fetchData'
  },
  computed: {
    username() {
      return this.$store.getters.username;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    toWWWAgotoZ() {
      // .open('/approval');
    },
    goBackHandler() {
      console.log(this.$route.matched, 'matched')
      const matched = this.$route.matched || []
      let prePageItem = {}
      for (const item of matched) {
        if (item.meta && item.meta.backPage) {
          prePageItem = item
          break
        }
      }
      /** 判断是history返回还是逻辑返回 */
      if (prePageItem.meta.isHistoryBack) {
        console.log(11111111)
        this.$router.go(-1)
      } else {
        let preUrl = prePageItem.redirect || prePageItem.path
        this.$router.replace(preUrl)
      }
    },
    fetchData() {
      const route = this.$route;
      this.title_label = route.query.title_label;
      this.label_remark = route.query.label_remark;
      this.label_remark_index = route.query.label_remark_index;
      this.title = route.meta.title;
      this.isBack = route.meta.isBack;
      this.dynamicTitle = !!route.meta.dynamicTitle;
      const crumbs = [];
      (route.matched || []).forEach(route => {
        if (!(route.meta && route.meta.isCrumb)) return;
        crumbs.push({
          path: route.path,
          name: route.name,
          regex: route.regex,
          redirect: route.redirect,
          title: route.meta.title,
          query: route.query
        });
      });
      this.crumbs = crumbs;
    },
    handleGoBack() {
      this.$router.go(-1);
    },
    cancelLogoutHandler() {
      this.logoutIsOpen = false;
    },
    handleLogout(command: string): any {
      this.logoutIsOpen = true;
    },
    confirmLogoutHandler() {
      this.logoutBtnIsLoading = true;
      this.$store.dispatch('FedLogOut').then(res => {
        this.logoutBtnIsLoading = false;
        location.href = '/login';
      }).catch(err => {
        console.error(err);
      });
    }
  }
};
</script>
